/**
 * @description: 判断用户菜单和操作权限，code根据实际配置情况配置
 *
 * 使用方式：
 * 1. v-permission=['ALARM_PAGE'] // 可以确定是否有报警菜单
 * 2. v-permission=['ALARM_PAGE.U'] // 可以确定是否有报警菜单中的更新操作
 * v-permission=['ALARM_PAGE']  // 对应权限码：`${fcPermission}ALARM_PAGE`
 * v-permission:FC=['ALARM_PAGE']  // 对应权限码：`${fcPermission}ALARM_PAGE`
 * v-permission:FM=['ALARM_PAGE']  // 对应权限码：`${fmPermission}ALARM_PAGE`
 */
import { Directive } from 'vue';
import { useUserStore } from '@/store/user';
import { useTenantStore } from '@/store/tenant';
import { intersection } from '@/utils/index';

/*
 * 自定义指令
 */
export const permission: Directive = {
  mounted(el: any, binding: any) {
    const userStore = useUserStore();
    const tenantStore = useTenantStore();
    const authKeys: string[] = userStore.authKeys;

    // 从租户 store 获取权限编码前缀
    const fmPermission = tenantStore.fmPermission;
    const fcPermission = tenantStore.fcPermission;

    const { value, arg = 'FC' } = binding; // 指令接收到的值

    if (value && value.length) {
      const typeKey = arg === 'FC' ? fcPermission : fmPermission;
      const hasPermission = intersection(
        authKeys,
        value.map((item: string) => `${typeKey}${item}`)
      ).length > 0;
      if (!hasPermission) {
        el.remove(); // 如果没有权限移除自身节点
      }
    } else {
      throw new Error('need roles! Like v-permission="[\'admin\',\'editor\',\'homepage.r\',\'homepage.u\']"');
    }
  },
};
